
const digest = 'f9d69c22ce7100a96309b5cd5ce56234ecfd5a284b0447382d55e64a7538c183';
const classes = {"wrapper":"_wrapper_179fn_1","greyBox":"_greyBox_179fn_15","whiteBox":"_whiteBox_179fn_28"};
const css = `._wrapper_179fn_1 {
  font-family: Poppins, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin: -34px -24px;
}
._wrapper_179fn_1 span {
  font-weight: 600;
}
._wrapper_179fn_1 img {
  height: 50px;
}
._wrapper_179fn_1 ._greyBox_179fn_15 {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f4f7;
  padding: 24px;
  width: 100%;
  flex-direction: column;
  gap: 10px;
}
._wrapper_179fn_1 ._greyBox_179fn_15 p {
  margin-bottom: 0;
}
._wrapper_179fn_1 ._whiteBox_179fn_28 {
  padding-bottom: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  